export type IconType =
  | 'activity-menu'
  | 'alert-circle'
  | 'arrow-left'
  | 'arrow-right'
  | 'attachment'
  | 'bell-03'
  | 'calendar'
  | 'calendar-check-01'
  | 'car-01'
  | 'chat'
  | 'check'
  | 'check-circle'
  | 'check-done-02'
  | 'chevron-down'
  | 'chevron-down-sm'
  | 'chevron-left'
  | 'chevron-left-double'
  | 'chevron-right'
  | 'circle-cut'
  | 'clock'
  | 'clock-rewind'
  | 'clock-stopwatch'
  | 'comment'
  | 'currency-dollar'
  | 'currency-dollar-circle'
  | 'details-menu'
  | 'dots-horizontal'
  | 'dots-vertical'
  | 'edit-05'
  | 'eye'
  | 'eye-off'
  | 'file-01'
  | 'filter-lines'
  | 'flag-01'
  | 'folder'
  | 'help-circle'
  | 'home'
  | 'home-02'
  | 'home-03'
  | 'home-icon'
  | 'home-line'
  | 'home-sad'
  | 'home-smile'
  | 'hourglass-03'
  | 'info-circle'
  | 'key-02'
  | 'layers-three-01'
  | 'link-03'
  | 'link-external-01'
  | 'log-out-04'
  | 'map-01'
  | 'menu-01'
  | 'message-check'
  | 'message-text-square-02'
  | 'pause-circle'
  | 'pencil-line'
  | 'phone'
  | 'plus'
  | 'property'
  | 'refresh-cw-01'
  | 'search-sm'
  | 'send-01'
  | 'sent-arrow'
  | 'settings-02'
  | 'settings-04'
  | 'technician'
  | 'tool-01'
  | 'tool-02'
  | 'trash-01'
  | 'upload'
  | 'upload-cloud-01'
  | 'user-circle'
  | 'users-02'
  | 'users-03'
  | 'vendor'
  | 'work-orders-menu'
  | 'x-circle'
  | 'x-close'
  | 'x-square';

export const SIZE_TYPES = ['2xl', 'xl', 'lg', 'md'] as const;

export type SizeType = (typeof SIZE_TYPES)[number];
export type SizePropType = SizeType | `${number}`;

export type ColorType = 'gray' | 'green' | 'blue' | 'red' | 'orange' | 'yellow' | 'purple' | 'pink';

type ShadeType = '' | '-dark' | '-darker' | '-light' | '-lighter' | '-lightest' | '-faint';

type StrokeColorVariant =
  `${Exclude<ColorType, 'pink'>}${Exclude<ShadeType, '-darker' | '-lightest' | '-faint'>}`;
type FillColorVariant = `${ColorType}${ShadeType}`;

export type StrokeColorType =
  | StrokeColorVariant
  | 'black'
  | 'white'
  | 'text'
  | 'ai'
  | 'gray-lightest';

export type FillColorType = FillColorVariant | 'none' | 'component';
